/* global googletag */

const setupAd = function(elementId, stream, index, postIds, beforeTags, afterTags, adId) {
  googletag.cmd.push(function() {
    googletag.defineSlot(`/227892952/axios/${stream}`, "fluid", elementId)
      .addService(googletag.pubads())
      .setTargeting("s1", stream)
      .setTargeting("pos", `mid${index}`)
      .setTargeting("pid", postIds)
      .setTargeting("kw-before", beforeTags)
      .setTargeting("kw-after", afterTags)
      .setTargeting("adid", adId || "");  // If there is no previous element, it's the first one and should be a permalink ad.
    googletag.enableServices();

    googletag.display(elementId);
  });
};

export default {
  setupAd,
};



// WEBPACK FOOTER //
// ./src/utils/gpt.js